/* eslint-disable no-undef */
import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Formik, Field, Form } from "formik";
import { ScrollContainer } from 'react-indiana-drag-scroll';
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import FormikErrorFocus from "formik-error-focus";
import { useFormik } from "formik";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import config from "../../config";
import Paginator from "../../shared/Paginator";
import { useDispatch, useSelector } from 'react-redux';
import { SetCampCount, SetOpsSales, SetComponentId } from '../../redux/counterSlice'
import {
  formatDate,
  formatDateWithTime,
  formatDateYYYYMMDD,
  NEWISODateString
} from "../../utils/dateFormat";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { debounce } from "../../utils/Debounce";
import { roles } from "../../utils/constants";
import { SlDrawer, SlButton, SlInput, SlIcon } from "@shoelace-style/shoelace/dist/react";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";

const initialState = {
  ro_no: "",
  ro_value: "",
  start_date: "",
  end_date: "",
  advertiser_id: "",
  company_name: "",
  advertiser_name: "",
  additional_amount: 0,
  additional_amount_approved_by: "",
};

let initialValues = JSON.parse(JSON.stringify(initialState));


function formatDateToReadable(date) {

  dispatch(SetComponentId(12))
  let given_date = new Date(date * 1000);
  let current_date =
    given_date.getDate() > 9
      ? given_date.getDate()
      : JSON.stringify(given_date.getDate()).padStart(2, "0");
  return `${given_date.getFullYear()}-${given_date.getMonth() + 1
    }-${current_date}`;
}

const AddRoSchema = Yup.object().shape({
  ro_no: Yup.string().matches(/^[a-zA-Z0-9][a-zA-Z0-9\s._]*$/, "Invalid RO Number and must have only Letters and Numericals").required(" RO Number is required"),
  ro_value: Yup.string().required("RO Value is required"),
  // advertiser_name: Yup.string().required('Advertiser is required'),
  start_date: Yup.date().required("Start Date is reqired"),
  end_date: Yup.date()
    .required("End Date is required")
    .min(Yup.ref("start_date"), "End date can't be before Start date"),
  company_name: Yup.string().required("Company Name is required").matches(/^[a-zA-Z0-9][a-zA-Z0-9\s.]*$/, "Enter valid company name"),
  advertiser_id: Yup.string().required("Advertiser Name is required"),
});

const AddAmountSchema = Yup.object().shape({
  additional_amount: Yup.number().min(
    1,
    "Additional Amount must be greater than Zero"
  ),
  additional_amount_approved_by: Yup.string().required(
    "Amount Approved by is required"
  ),
});

function RoUser() {
  const dispatch = useDispatch()
  dispatch(SetComponentId(12))
  const navigate = useNavigate();
  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role !== roles.ops && role !== roles.financer)
      navigate("/pagenotfound");
    setCurrentDate(NEWISODateString().slice(0, 10))

  }, []);

  // const [advertiser_id, setAdvId] = useState('')
  // const [advertiser_name, setAdvName] = useState('')
  const [company, setCompany] = useState([]);
  const [advertisers, setAdvertisers] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [submit, setSubmit] = useState(false);
  const [currentDate, setCurrentDate] = useState("");
  const HeaderSearch = useSelector(state => state.Head.adssearch);
  const [campdata, setCampData] = useState([]);
  const [downloadData, setDownloadData] = useState([])
  const [preview, setPreview] = useState(false);
  const [pages, setPages] = useState(0);
  const [presentPage, setPresentPage] = useState(0);
  const [ro, setRo] = useState("")

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };
  const handlePages = async (event) => {
    setPresentPage(event.selected);
    await campaignData(ro, event.selected);
    setPreview(true)

  }
  const loadCompany = async () => {
    try {
      const response = await api({
        url: `/creatives/image/companyname`,
        method: "GET",
        responseType: "json",
      });
      if (response?.data?.result) {
        setCompany(response?.data?.result);
      }
    } catch (error) {
      console.log("error");
    }
  };

  const [show, setShow] = useState(false);
  const [flag, setFlag] = useState("");
  const [amid, setAmid] = useState("");

  const handleClose = () => {
    initialValues = JSON.parse(JSON.stringify(initialState));
    formik.setValues(initialValues);
    setShow(false);
    setSubmit(false);
    // initialState.ro_no = "";
    // initialState.ro_value = "";
    // initialState.start_date = "";
    // initialState.end_date = "";
    // initialState.advertiser_id = "";
    // initialState.advertiser_name = "";
    // initialState.company_name = "";
    // setAdvId("")
    // setAdvName("")
  };

  function handleRequestClose(event) {
    if (event.detail.source === 'overlay') {
      event.preventDefault();
    }
  }
  const handleShow = async (choose, item) => {
    if (choose === "create") {
      formik.setValues(item);
      setShow(true);
    }
    if (choose === "add") {
      setShow(true);
    }
    if (choose === "edit") {
      initialValues.ro_no = item.ro_no;
      initialValues.ro_value = item.ro_value;
      initialValues.start_date = formatDateYYYYMMDD(item.start_date);
      initialValues.end_date = formatDateYYYYMMDD(item.end_date);
      initialValues.advertiser_name = item.advertiser_name;
      initialValues.advertiser_id = item.advertiser_id;
      initialValues.company_name = item.company_name;
      await loadCompany();
      await getAdvertisers(item.company_name);
      formik.setValues(initialValues);
      // setAdvId(item.advertiser_id)
      // setAdvName(item.advertiser_name)
      setShow(true);
    }
  };

  // const loadId = async () => {

  //   try {
  //     const response = await api({
  //       url: `/ro/advIdName`,
  //       method: "GET",
  //       responseType: "json"
  //     });
  //     setAdvId(response.data.result)
  //   } catch (error) {
  //     console.log("error")
  //   }
  // }

  // useEffect(() => {
  //   loadId();
  // }, []);

  const [data, setData] = useState([]);

  const loadData = async (searchString = "", page = 0) => {
    setLoader(true);
    const response = await api({
      url: `/ro/getRos`,
      method: "POST",
      responseType: "json",
      data: {
        page,
        limit: config.PER_PAGE,
        search: searchString,
      },
    });
    if (response?.code === 200) {
      setData(response.data.data);
      setTotalPages(Math.ceil(response.data.total / config.PER_PAGE));
      setLoader(false);
    } else {
      toast.error(response?.data?.message);
      setLoader(false)
    }

  };


  const campaignData = async (ro_no, page = 0) => {
    setLoader(true);
    const response = await api({
      url: `/ro/campaignDetails`,
      method: "POST",
      responseType: "json",
      data: {
        ro_no: ro_no,
        page,
        limit: config.PER_PAGE
      }
    })
    if (response?.code !== 200) {
      toast.error(response?.data?.message)
    } else {
      setCampData(response?.data?.data?.campaigns);
      setPreview(!preview);
      setPages(Math.ceil(response.data.total / config.PER_PAGE));
      setLoader(false);
    }
  }

  const downloadCampaignData = async (ro_no) => {
    setLoader(true);
    const response = await api({
      url: `/ro/downloadCampaigns`,
      method: "POST",
      responseType: "json",
      data: {
        ro_no: ro_no,
      }
    })
    if (response?.code !== 200) {
      toast.error(response?.data?.message)
    } else {
      setDownloadData(response?.data?.data?.downloadCampaigns);
      setPreview(!preview);
      setLoader(false);
    }
  }

  // useEffect(() => {
  //     const timer = setTimeout(() => {
  //         loadData()
  //     }, 200);

  //     return () => clearTimeout(timer);
  // }, [search]);

  // useEffect(() => {
  //     loadData();
  // }, []);

  useEffect(() => {
    Header()
  }, [HeaderSearch])

  const Header = () => {
    setSearch(HeaderSearch);
    setCurrentPage(0);
  }

  const getAdvertisers = async (company) => {
    try {
      const response = await api({
        url: `/creatives/image/advIdName`,
        method: "POST",
        responseType: "json",
        data: { company },
      });
      setAdvertisers(response?.data?.result);
    } catch (error) {
      console.log("error");
    }
  };

  const csvHeaders = [
    { label: "Campaign Name", key: "campaign_name" },
    { label: " Campaign Type", key: "campaign_type" },
    { label: "Start Date", key: "start_date" },
    { label: "End Date", key: "end_date" },
    { label: "CPM", key: "cpm" },
    { label: "CPC", key: "cpc_price" },
    { label: "CPD", key: "cpd" },
    { label: "Clicks", key: "clicks" },
    { label: "Impressions", key: "impressions" },
    { label: "Spent", key: "spent" },
  ];
  const filteredData = downloadData.map(
    ({
      campaign_name,
      campaign_type,
      start_date,
      end_date,
      cpd,
      cpc_price,
      cpm,
      clicks,
      imps,
      amountSpent
    }) => {
      const startDate = formatDate(start_date);
      const endDate = formatDate(end_date);
      return {
        campaign_name,
        campaign_type,
        start_date: startDate,
        end_date: endDate,
        impressions: imps,
        cpd,
        cpc_price,
        cpm,
        clicks: clicks,
        spent: amountSpent,
      };
    }
  );

  let formik = useFormik({
    initialValues: JSON.parse(JSON.stringify(initialState)),
    validationSchema: AddRoSchema,
    onSubmit: async (values, { resetForm }) => {
      if (flag === "create") {
        try {
          let res = await api({
            url: `/ro/create`,
            method: "POST",
            responseType: "json",
            data: values,
          });
          if (res?.code !== 200) {
            Toast('error', res?.data?.message);
          } else {
            handleClose();
            setCurrentPage(0);
            setSearch("");
            loadData("", 0);
            resetForm();
            Toast("success", "RO Added Successfully");
          }
        } catch (error) {
          Toast("error", "Something went Wrong")
        }

      }

      if (flag === "edit") {
        try {
          let res = await api({
            url: `/ro/edit`,
            method: "PUT",
            responseType: "json",
            data: {
              ro_no: values.ro_no,
              ro_value: values.ro_value,
              start_date: values.start_date,
              end_date: values.end_date,
              advertiser_id: values.advertiser_id,
              company_name: values.company_name,
              ro_id: amid,
            },
          });
          if (res?.code !== 200) {
            Toast('error', res?.data?.message);
          } else {
            resetForm();
            handleClose();
            loadData(search, currentPage);
            Toast("success", "RO Edited Successfully...........");
          }

        } catch (error) {
          Toast("error", "Something went wrong")
          if (error.response.status === 401)
            navigate("/")
        }
      }

    }
  });


  useEffect(() => {
    loadData(search, currentPage);
  }, [search, currentPage]);

  const searchData = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
  };

  return (
    <>
      <header className="flex items-center mb-3">
        <h5>RO</h5>
        {/* <aside class="flex gap-3 ml-auto"> */}
        <aside className="ml-auto flex items-center gap-3">
          <div>
            <SlInput
              size="small"
              id="myInput"
              onSlInput={debounce(searchData, 500)}
              placeholder="Search by RO No/Advertiser/Company">
              <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
            </SlInput>
          </div>
          <div>
            <SlButton
              size="small"
              variant="primary"
              onClick={() => {
                handleShow("create", {});
                setFlag("create");
                loadCompany();
              }}>Add RO</SlButton>
          </div>
        </aside>
      </header>


      <div className="overflow-x-auto mb-4">
        <ScrollContainer>
          <table className=" table table-bordered">
            <thead className="sticky top-0 ">
              <tr>
                <th width="100px">RO No</th>
                <th width="100px">RO Value</th>
                <th width="140px">Company Name</th>
                <th width="140px">Advertiser Name</th>
                <th width="160px">Start Date</th>
                <th width="160px">End Date</th>
                <th width="140px">Impressions</th>
                <th width="140px">Clicks</th>
                <th width="100px">Amount Spent</th>
                <th width="160px">Created Date</th>
                <th width="80px">Status</th>
                <th width="80px">Actions</th>
              </tr>
            </thead>
            {data?.length && !loader ? (
              <tbody>
                {data.map((item) => {
                  return (
                    <tr key={item.ro_id} className="group/details hover:bg-slate-100">
                      {/* <th scope='row'> </th> */}
                      {/* <td className="wgt-600">{item.ro_no}</td> */}
                      <td>
                        <div style={{ color: "blue", cursor: "pointer" }} onClick={async () => { setRo(item.ro_no); await campaignData(item.ro_no, presentPage); await downloadCampaignData(item.ro_no) }}>{item.ro_no}</div>
                      </td>
                      <td>{item.ro_value}</td>
                      {/* <td>{item.additional_amount}</td>
                                            <td>{item.additional_amount_approved_by || '-'}</td> */}
                      <td>{item.company_name || "-"}</td>
                      <td>{item.advertiser_name || "-"}</td>
                      <td>{formatDate(item.start_date)}</td>
                      <td>{formatDate(item.end_date)}</td>
                      <td>{item.total_imps}</td>
                      <td>{item.total_clicks}</td>
                      <td>{`₹${item.amountSpent}`}</td>
                      <td>{formatDateWithTime(item.created_date)}</td>
                      <td>
                        {item.status === 0
                          ? <span className="pending-badge">pending</span>
                          : item.status === 1
                            ? <span className="processing-badge"> Processing</span>
                            : <span className="badge badge-success"> Completed</span>}
                      </td>
                      <td>
                        <sl-tooltip content="Edit RO Details">
                          <sl-icon-button
                            library="lucide"
                            name="edit"
                            onClick={() => { handleShow("edit", item); setFlag("edit"); setAmid(item.ro_id); }}></sl-icon-button>
                        </sl-tooltip>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            ) : !data?.length && !loader ? (
              <NoDataFound colspan="11" />
            ) : (
              <TableLoader colspan="11" />
            )}
          </table>
        </ScrollContainer>
      </div>
      <div className="flex justify-end">
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage} />)}
      </div>
      <SlDrawer label="RO Details" open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} style={{ '--size': '640px' }}>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <label> RO Number</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter RO Number"
              aria-label=""
              name="ro_no"
              disabled={flag === "edit" ? true : false}
              value={formik.values.ro_no}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.ro_no ? (
              <div className="text-red-600	">{formik.errors.ro_no}</div>
            ) : null}
          </div>

          <div className="mb-3">
            <label>RO Value</label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter Ro Value"
              aria-label=""
              name="ro_value"
              disabled={flag === "edit" ? true : false}
              value={formik.values.ro_value}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.ro_value ? (
              <div className="text-red-600	">{formik.errors.ro_value}</div>
            ) : null}
          </div>

          <div className="mb-3">
            <label>Start Date</label>
            <input
              type="date"
              name="start_date"
              className="form-control"
              placeholder="Choose the Start Date"
              aria-label=""
              disabled={flag === "edit" ? true : false}
              value={formik.values.start_date}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              min={currentDate}
            />
            {submit && formik.errors.start_date ? (
              <div className="text-red-600	">{formik.errors.start_date}</div>
            ) : null}
          </div>

          <div className="mb-3">
            <label>End Date</label>
            <input
              type="date"
              name="end_date"
              className="form-control"
              placeholder="Choose End Date"
              aria-label=""
              value={formik.values.end_date}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              min={currentDate}
            />
            {
              submit && formik.errors.end_date ? (
                <div className="text-red-600	">{formik.errors.end_date}</div>
              ) : null
            }
          </div>

          <div className="mb-3">
            <label>
              {" "}
              Company Name
            </label>
            <select
              className="form-select"
              aria-label="Select Company"
              name="company_name"
              placeholder="Select Company"
              onBlur={formik.handleBlur}
              disabled={flag === "edit" ? true : false}
              value={formik.values.company_name}
              onChange={(e) => {
                formik.handleChange(e);
                // setFieldValue("company_name", e.target.value);
                getAdvertisers(e.target.value);
                // setFieldValue("advertiser_id", "");
              }}
            >
              <option value="" key="-1">Select Company</option>
              {company.map((item, index) => {
                return (
                  <option value={item.value} key={item.index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
            {submit && formik.errors.company_name ? (
              <div className="text-red-600	">{formik.errors.company_name}</div>
            ) : null}
          </div>

          <div className="mb-3">
            <label> Advertiser</label>
            <select
              className="form-select"
              aria-label="Select Advertiser"
              name="advertiser_id"
              placeholder="Select Advertiser"
              onBlur={formik.handleBlur}
              disabled={flag === "edit" ? true : false}
              value={formik.values.advertiser_id}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            >
              <option value="" key="-1">Select Advertiser</option>
              {advertisers.map((item, index) => {
                return (
                  <option value={item.value} key={item.index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
            {submit && formik.errors.advertiser_id ? (
              <div className="text-red-600	">{formik.errors.advertiser_id}</div>
            ) : null}
          </div>

          <div slot="footer">
            <SlButton
              type="submit"
              variant="primary"
              size="small"
              onClick={(e) => setSubmit(true)}>Submit</SlButton>
          </div>

        </form>
      </SlDrawer>
      <SlDrawer
        label={`Campaignwise Details of ${ro}`}
        open={preview}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={() => { setPreview(false); setPresentPage(0); setRo("") }}
        style={{ "--size": "70vw" }}
      >
        <div className="flex justify-end mb-5">
          <CSVLink
            data={filteredData}
            headers={csvHeaders}
            filename={`Campaign_Details_of_${ro}.csv`}
          >
            <sl-icon-button
              library="lucide"
              title="Download"
              name="download"
            ></sl-icon-button>
          </CSVLink>
        </div>
        <div className="overflow-x-auto">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Campaign Name</th>
                <th>Campaign Type</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>CPM</th>
                <th>CPC</th>
                <th>CPD</th>
                <th>Clicks</th>
                <th>Impressions</th>
                <th>Spent</th>
              </tr>
            </thead>
            {campdata?.length && !loader ? (
              <tbody>
                {campdata.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td >{item.campaign_name || "-"}</td>
                      <td>{item.campaign_type || "-"}</td>
                      <td>{formatDate(item.start_date)}</td>
                      <td>{formatDate(item.end_date)}</td>
                      <td >{`₹${item.cpm}` || "-"}</td>
                      <td>{`₹${item.cpc_price}` || "-"}</td>
                      <td>{`₹${item.cpd}` || "-"}</td>
                      <td>{item.clicks}</td>
                      <td>{item.imps}</td>
                      <td>{`₹${item.amountSpent}`}</td>
                    </tr>
                  );
                })}
              </tbody>
            ) : !campdata?.length && !loader ? (
              <NoDataFound colspan="8" />
            ) : (
              <TableLoader colspan="8" />
            )}
          </table>
        </div>
        <div className="flex justify-end">
          {pages > 1 && (
            <Paginator
              pageCount={pages}
              handlePageClick={handlePages}
              forcePage={presentPage} />)}
        </div>
      </SlDrawer>
      {/* <Modal
        show={show && (flag === "create" || flag === "edit")}
        onHide={handleClose}
        animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>RO Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            id="11111111"
            initialValues={initialState}
            validationSchema={AddRoSchema}
            onSubmit={async (values, { resetForm }) => {
              // values.advertiser_name = advertiser_name
              // values.advertiser_id = values.advertiser_id
              if (flag === "create") {
                // if (values.advertiser_name === '') {
                //     Toast('error', "Advertiser is required")
                // }
                // else {
                await api({
                  url: `/ro/create`,
                  method: "POST",
                  responseType: "json",
                  data: values,
                });

                handleClose();
                setCurrentPage(0);
                setSearch("");
                loadData("", 0);
                resetForm();
                Toast("success", "RO Added Successfully...........");
                // }
              }

              if (flag === "edit") {
                await api({
                  url: `/ro/edit`,
                  method: "PUT",
                  responseType: "json",
                  data: {
                    ro_no: values.ro_no,
                    ro_value: values.ro_value,
                    start_date: values.start_date,
                    end_date: values.end_date,
                    advertiser_id: values.advertiser_id,
                    company_name: values.company_name,
                    // advertiser_name: advertiser_name,
                    ro_id: amid,
                  },
                });
                resetForm();
                // initialState.ro_no = ""
                // initialState.ro_value = ""
                // initialState.start_date = ""
                // initialState.end_date = ""
                // initialState.advertiser_id = ""
                // initialState.advertiser_name = "";
                // initialState.company_name = "";
                // setAdvId("")
                // setAdvName("")
                handleClose();
                loadData(search, currentPage);
                Toast("success", "RO Edited Successfully...........");
              }
            }}
          >
            {({ values, errors, touched, setFieldValue }) => (
              <Form className="px-3">
                <div className="mb-3">
                  <label> RO Number</label>
                  <Field
                    type="text"
                    name="ro_no"
                    className="form-control"
                    placeholder="Enter RO Number"
                  />
                  {errors.ro_no && touched.ro_no ? (
                    <div className="text-red-600">{errors.ro_no}</div>
                  ) : null}
                </div>
                <div className="mb-3">
                  <label>RO Value</label>
                  <Field
                    type="number"
                    name="ro_value"
                    className="form-control"
                    placeholder="Enter RO Value "
                  />
                  {errors.ro_value && touched.ro_value ? (
                    <div className="text-red-600">{errors.ro_value}</div>
                  ) : null}
                </div>
                <div className="mb-3">
                  <label>Start Date</label>
                  <Field
                    type="date"
                    name="start_date"
                    className="form-control"
                    placeholder="Choose the Start Date"
                  />
                  {errors.start_date && touched.start_date ? (
                    <div className="text-red-600">{errors.start_date}</div>
                  ) : null}
                </div>
                <div className="mb-3">
                  <label>End Date</label>
                  <Field
                    type="date"
                    name="end_date"
                    className="form-control"
                    placeholder="Choose End Date"
                  />
                  {errors.end_date && touched.end_date ? (
                    <div className="text-red-600">{errors.end_date}</div>
                  ) : null}
                </div>
                <div className="mb-3">
                  <label>
                    {" "}
                    Company Name
                  </label>
                  <Field
                    as="select"
                    name="company_name"
                    aria-label="Select Company"
                    className="form-control"
                    onChange={(e) => {
                      setFieldValue("company_name", e.target.value);
                      getAdvertisers(e.target.value);
                      setFieldValue("advertiser_id", "");
                    }}
                  >
                    <option value="" key="-1">
                      Select Company
                    </option>
                    {company.map((item, index) => {
                      return (
                        <option value={item.value} key={index}>
                          {item.label}
                        </option>
                      );
                    })}
                  </Field>
                  {errors.company_name && touched.company_name ? (
                    <div className="text-red-600">{errors.company_name}</div>
                  ) : null}
                </div>
                <div className="mb-3">
                  <label> Advertiser</label>
                  <Field as="select" name="advertiser_id" aria-label="Select Advertiser" className="form-control">
                    <option value="" key="-1">
                      Select Advertiser
                    </option>
                    {advertisers.map((item, index) => {
                      return (
                        <option value={item.value} key={index}>
                          {item.label}
                        </option>
                      );
                    })}
                  </Field>
                  {errors.advertiser_id && touched.advertiser_id ? (
                    <div className="text-red-600">{errors.advertiser_id}</div>
                  ) : null}
                </div>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
                <FormikErrorFocus
                  offset={0}
                  align={"top"}
                  focusDelay={100}
                  ease={"linear"}
                  duration={100}
                />
              </Form>
            )}
          </Formik>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal> */}
    </>
  );
}
export default RoUser;
